import BaseResource from './index'
import CompanyResource from './company'

export default class UserResource extends BaseResource {
    static endpoint = '/users'

    static login(username, password) {
        let receivedToken = undefined
        return UserResource.client
            .post(`/auth`, { username, password })
            .then((res) => {
                receivedToken = res.data.token
                return res.data.token
            })
            .then((token) => {
                BaseResource.client.token = token
                let payload = BaseResource.client.getTokenPayload()
                if (payload['user_id']) {
                    return UserResource.detail(payload['user_id'])
                } else {
                    return new UserResource()
                }
            })
            .then((userResource) => {
                return {
                    userResource,
                    token: receivedToken,
                }
            })
    }

    async setPassword(newPassword) {
        let endpoint = this.wrap('/update_password')
        return await endpoint.post({ new_password: newPassword })
    }

    static async forgotPassword(email) {
        let endpoint = this.wrap('/forgot_password')
        return await endpoint.post({ email })
    }

    async getPermissions() {
        let result = await UserResource.client.get(`/auth/permissions`)
        return result.data
    }

    async getCompanies() {
        return await CompanyResource.filterAll({ owner: this.id })
    }

    static async getMessagesRecent() {
        let wrapped = this.wrap('/messages/recent')
        let result = await wrapped.get()
        let conneg = this.client.negotiateContent(this)
        return conneg(result)
    }

    async getProfile() {
        const DeveloperProfileResource = require('./developerprofile').default
        let profiles = this.readonly.profiles

        if(profiles.length > 0) {
            return await DeveloperProfileResource.detail(profiles[0])
        }

        return null
    }

    toString() {
        let hiString = [this.get('first_name'), this.get('last_name')].filter((v) => !!v).join(' ')
        if (!hiString.length) {
            hiString = this.get('email')
        }
        return hiString
    }

    toJSON() {
        let obj = super.toJSON()
        delete obj['password']
        return obj
    }
}
